<template>
  <!-- 编辑弹框子组件 -->
  <div class="part">
    <el-dialog :visible.sync="EditdialogForm" width="50%" center class="dialogItem" :close-on-click-modal="false">
      <el-form :ref="formData" :model="formData" label-width="120px">
        <el-form-item label="客户姓名">
          <el-input v-model.trim="formData.customerName" style="width: 90%" clearable> </el-input>
        </el-form-item>
        <el-form-item label="卡号" prop="cadCode">
          <el-input @input="testSX" v-model.trim="formData.cadCode" style="width: 90%"
            onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" clearable> </el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input @input="testSX" v-model.trim="formData.mobile" style="width:80%"
            onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" clearable> </el-input>
          <el-button class="info" type="primary" @click="getInfo" size="mini">获取信息</el-button>
        </el-form-item>
        <el-form-item label="预约门诊时间">
          <el-date-picker format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" v-model="formData.appointmentTime"
            type="datetime" placeholder="选择日期时间" style="width: 90%" :picker-options="disabledDate" @focus="pickDateFocus"
            @change="pickDateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="项目类型">
          <el-select v-model="formData.projectType" placeholder="请选择项目类型" style="width:90%" @change="editTypeChange">
            <el-option v-for="item in projectTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="formIndex">
          <el-form-item label="院区/楼层">
            <el-select @change="areaChange" :disabled="areaDisabled" v-model="formData.areaCode" placeholder="请选择院区"
              style="width: 45%">
              <el-option v-for="(item, index) in areaOptions" :key="index" :label="item.areaName" :value="item.areaCode">
              </el-option>
            </el-select>
            <el-select v-model="formData.floorCode" :disabled="floorDisabled" placeholder="请选择楼层" style="width: 45%"
              @change="floorChangeCopy">
              <el-option v-for="(item, index) in floorOptions" :key="index" :label="item.floorName"
                :value="item.floorCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预约项目" prop="projectName">
            <el-select v-model="formData.projectId" @change="projectChangeEdit" @focus="projectFocus"
              :remote-method="(query) => { projectMethod(query, formData.projectType) }" filterable remote clearable
              placeholder="请输入搜索预约项目" style="width: 90%">
              <el-option v-for="item in projectOptions" :key="item.id" :label="item.projectName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="宏脉项目名称" prop="hmProjectName">
            <el-input style="width: 90%" v-model="formData.hmProjectName" disabled></el-input>
          </el-form-item>
          <el-form-item label="仪器" prop="instrumentName" class="instrumentName">
            <el-select v-model="formData.instrumentId" placeholder="请选择" @input="testSX" @change="instrumentChange1"
              style="width: 90%">
              <el-option v-for="(item, index) in projectInstrument" :key="index" :label="item.instrumentName"
                :value="item.instrumentId"></el-option>
            </el-select>
          </el-form-item>
          <div class="appointTime" v-if="editShowTime">
            <el-select :class="value == '1' ? 'tips' : 'tooltips'" v-model="value" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <div>
              <div class="appointTimeLong" v-if="value == '0'">
                <span v-for="(list, index) in editSuccessAppointTime.occupied" :key="index">
                  <el-tag type="danger">{{ list.instrumentDate }}</el-tag>
                </span>
              </div>
              <div class="appointTimeLong" v-if="value == '1'">
                <span v-for="(list, index) in editSuccessAppointTime.unoccupied" :key="index">
                  <el-tag>{{ list.instrumentDate }}</el-tag>
                </span>
              </div>
            </div>
          </div>
          <div v-for="(domain, idx) in editEppointmentPosition " :key="idx">
            <div class="instrucPosition">
              <el-form-item :label="'部位' + (idx + 1)">
                <el-select v-model="domain.positionId" @change="editPositionChange($event, idx)"
                  @focus="editPositionFocus($event, idx)" clearable placeholder="请选择仪器使用部位" style="width:45%;"
                  @input="testSX">
                  <el-option v-for="(ite, index) in editPositionOptions" :key="index"
                    :label="ite.positionName + '~' + ite.useMinute + '分钟'" :value="ite.positionId"
                    :disabled="ite.disabled">
                  </el-option>
                </el-select>
                <el-time-select v-if="timeFlag" @input="testSX" v-model="domain.useTime"
                  :picker-options="{ start: '09:00', step: '00:05', end: '23:00' }" @focus="editDateFocus"
                  @change="dateChange($event, idx)" placeholder="选择仪器部位使用时间"></el-time-select>
                <el-time-select v-if="dateFlag" @input="testSX" @change="dateChange($event, idx)" v-model="domain.useTime"
                  :picker-options="{ start: '08:00', step: '01:00', end: '23:00' }" placeholder="选择仪器部位使用时间"
                  @focus="editDateFocus"></el-time-select>
                <el-button size="mini" type="danger" @click.prevent="editRemoveDomain(domain, idx)" v-show="idx > 0">
                  <i class="el-icon-delete"></i>
                </el-button>
              </el-form-item>
            </div>
          </div>
          <el-form-item style="text-align: right;margin-right:5%;">
            <el-button @click="editAddDomain" type="primary" size="mini">新增部位</el-button>
          </el-form-item>
          <el-form-item label="操作人" prop="doctorName">
            <el-select v-model="formData.doctorId" placeholder="请选择" style="width: 90%" @change="docotrChange1"
              @focus="docotrFocusEdit">
              <el-option v-for="(item, index) in projectDoctor" :key="index" :label="item.doctorName"
                :value="item.doctorId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="初诊/复诊" prop="appointStatus">
            <el-select v-model="formData.appointStatus" placeholder="请选择" style="width: 90%">
              <el-option v-for="option in typeOptions" :key="option.value" :label="option.text" :value="option.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input style="width: 90%" v-model="formData.remark" type="textarea" autosize></el-input>
          </el-form-item>
          <div class="clearBottom">
            <div class="partFooter">
              <el-button type="danger" @click="EditdialogForm = false">取 消</el-button>
              <el-button type="primary" @click="edit()">确 定</el-button>
            </div>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'editAppoint',
  props: ['formData', 'getInfoList', 'getList', 'fatherId'],
  data() {
    return {
      editPositionOptions: {},
      typeOptions: [{
        text: '初诊',
        value: 0
      },
      {
        text: '复诊',
        value: 1
      },
      {
        text: 'VIP',
        value: 2
      },
      ],
      areaOptions: [{
        areaName: '伯思立',
        areaCode: 'bsl'
      }, {
        areaName: '翡立思',
        areaCode: 'fls'
      }, {
        areaName: '南通伯思立',
        areaCode: 'ntbsl'
      }],
      floorOptions: [{
        floorName: '2楼',
        floorCode: '2'
      }, {
        floorName: '3楼',
        floorCode: '3'
      },
      {
        floorName: '12楼',
        floorCode: '12'
      },
      ],
      copyProjectName: '',
      appointmentId: "",
      projectOptions: [],
      projectData: [],
      EditdialogForm: false,
      disabled: false,
      projectInstrument: [],
      projectDoctor: [],
      dataParam: "",
      listName1: '',
      listName2: '',
      arrList3: [],
      arrList4: [],
      projectIdData: '',
      disabledDate: {
        disabledDate: (time) => {
          return time.getTime() < new Date().getTime() - 8.64e7
        },
      },
      projectDoctorList: [],
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
      },
      editEppointmentPosition: {},
      instrumentNum: '',
      focusTime: '',
      editShowTime: false,
      editSuccessAppointTime: '',
      options: [{
        value: '0',
        label: '当日已预约时间'
      }, {
        value: '1',
        label: '当日可预约时间'
      }],
      value: '1',
      projectTypeOptions: [{
        value: '1',
        label: '皮肤'
      }, {
        value: '2',
        label: '注射'
      }, {
        value: '3',
        label: '其他'
      }],
      dateFlag: false,
      timeFlag: true,
      offFirstEnter: false,
      areaType: Lockr.get('areaType'),
      cityCode: Lockr.get('cityCode'),
      areaDisabled: true,
      floorDisabled: false,
    };
  },
  created() {
    if (!this.areaType || this.areaType == undefined) {
      this.areaDisabled = false
    }
    if (this.areaType == 'fls') {
      this.formData.floorCode = '1'
      this.floorDisabled = true
      this.floorOptions = [{
        floorName: '1楼',
        floorCode: '1'
      }]
    } else if (this.areaType == 'bsl') {
      this.floorDisabled = false
      this.floorOptions = [{
        floorName: '2楼',
        floorCode: '2'
      }, {
        floorName: '3楼',
        floorCode: '3'
      },
      {
        floorName: '12楼',
        floorCode: '12'
      },]
    } else if (this.areaType == 'ntbsl') {
      this.formData.floorCode = '1'
      this.floorDisabled = true
      this.floorOptions = [{
        floorName: '1楼',
        floorCode: '1'
      }]
    }
  },
  watch: {
    getInfoList: function (newVal, oldVal) {
      this.dateFlag = false;
      this.timeFlag = true;
      this.editShowTime = false;
      this.showOrHide(newVal.projectName)
      this.projectInstrument = newVal.projectInstrument
      this.projectDoctor = newVal.projectDoctor
      this.projectDoctorList = newVal.projectDoctor
      this.value = '1'
    },
    getList: {
      handler(newVal, oldVal) {
        this.editEppointmentPosition = newVal
        this.editEppointmentPosition.forEach(ele => {
          ele.useTime = ele.useTimeStart
        });
        if (!this.offFirstEnter) {
          return;
        }
        this.getFatherData()
      }
    },
    formData: {
      handler(newVal, oldVal) {
        console.log(newVal)
        if (newVal.areaCode == 'fls') {
          this.formData.floorCode = '1'
          this.floorDisabled = true
          this.floorOptions = [{
            floorName: '1楼',
            floorCode: '1'
          }]
        } else if (newVal.areaCode == 'bsl') {
          this.floorDisabled = false
          this.floorOptions = [{
            floorName: '2楼',
            floorCode: '2'
          }, {
            floorName: '3楼',
            floorCode: '3'
          },
          {
            floorName: '12楼',
            floorCode: '12'
          },]
        } else if (newVal.areaCode == 'ntbsl') {
          this.formData.floorCode = '1'
          this.floorDisabled = true
          this.floorOptions = [{
            floorName: '1楼',
            floorCode: '1'
          }]
        }
      }
    },
  },
  methods: {
    // 获取信息
    getInfo() {
      if (this.formData.cadCode == '' && this.formData.mobile == '') {
        _g.toast("warning", '请填写手机号或卡号');
        return;
      }
      // this.formData.customerName = ""
      Lockr.set("selected", 1)
      this.loading = true
      let data = {
        clientCard: this.formData.cadCode,
        clientMobile: this.formData.mobile,
        clientName: this.formData.customerName,
        pageIndex: 1,
      }
      api.requestQuiet("/register/getClientInformation", data, (res) => {
        console.log(res)
        if (res.result == true) {
          this.loading = false
          if (res.data.mapList.length == 1) {
            this.formData.mobile = res.data.mapList[0].clientMobile
            this.formData.cadCode = res.data.mapList[0].clientCard
            this.formData.customerName = res.data.mapList[0].clientName
            this.$forceUpdate()
          } else {
            let loadOptions = res.data.mapList
            this.$emit('editDialog', loadOptions)

          }
        } else {
          this.loading = false
          //   获取信息之后是否可以编辑信息
          this.disabled = false
          _g.toast("warning", '请手动添加客户信息');
        }
      }, (err) => {
        this.loading = false
      });
    },
    areaChange(val, index) {
      if (val == 'fls') {
        this.formData.floorCode = '1'
        this.floorDisabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      } else if (val == 'bsl') {
        this.formData.floorCode = ''
        this.floorDisabled = false
        this.floorOptions = [{
          floorName: '2楼',
          floorCode: '2'
        }, {
          floorName: '3楼',
          floorCode: '3'
        },
        {
          floorName: '12楼',
          floorCode: '12'
        },]
      } else if (val == 'ntbsl') {
        this.formData.floorCode = '1'
        this.floorDisabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      }
    },
    // 仪器部位时间选择器切换
    showOrHide(projectName) {
      let ss = projectName.includes('热拉提')
      let vv = projectName.includes('热玛吉')
      if (ss == true || vv == true) {
        this.dateFlag = true
        this.timeFlag = false
      } else {
        this.dateFlag = false
        this.timeFlag = true
      }
    },
    // 点击编辑时部位回显
    getFatherData() {
      // 部位回显
      api.request("/instrument/findInstrumentById", {
        instrumentId: this.formData.instrumentId
      }, (res) => {
        this.$nextTick(() => {
          this.editPositionOptions = res.data.InstrumentPosition
          this.editPositionOptions.map((x, i) => {
            this.editEppointmentPosition.map((s) => {
              if (x.positionId === s.positionId) {
                x.disabled = true
              }
            })
          })
          this.$forceUpdate()
        });
      }, (err) => { })
      // // 根据预约门诊时间和仪器id提示仪器已预约时间
      if (this.formData.instrumentId != '') {
        let queryData = {
          appointmentTime: this.formData.appointmentTime,
          instrumentId: this.formData.instrumentId,
        }
        api.request("/appointment/findInstrumentDateById", queryData, (res) => {
          if (res.result == true) {
            let dataTimeAppoint = res.data
            if (dataTimeAppoint.unoccupied) {
              this.editShowTime = true
              this.editSuccessAppointTime = dataTimeAppoint
            } else if (!dataTimeAppoint.unoccupied) {
              this.editShowTime = false
            }
          }
          this.$forceUpdate()
        }, (err) => { });
      }
      // 点击编辑项目回显
      let querys = {
        projectName: "",
        projectType: this.formData.projectType,
        areaCode: this.formData.areaCode,
        cityCode: this.cityCode
      };
      api.request("/project/findProjectListByName", querys, (res) => {
        if (res.data.length == 0) {
          _g.toast("warning", "还没有可选择的项目!");
        }
        this.projectOptions = res.data;
      }, (err) => { });
    },
    openDialog1Visible() {
      this.offFirstEnter = true
      this.EditdialogForm = true;
    },
    editDateFocus() {
      this.formData.doctorId = ''
    },
    // 编辑时热拉提项目两小时时间制
    dateChange(val, index) {
      val = this.formData.appointmentTime.split(' ')[0] + ' ' + val + ':00'
      var oDate1 = new Date(this.formData.appointmentTime);
      var oDate2 = new Date(val);
      if (oDate1) {
        if (oDate1.getTime() > oDate2.getTime()) {
          _g.toast("warning", "预约仪器时间不得早于预约门诊时间");
          this.editEppointmentPosition[index].useTime = ''
          this.$forceUpdate()
          return; //第一个大
        }
      }
      this.editEppointmentPosition[index].useTime = val
      this.$forceUpdate()
    },
    pickDateFocus(val) {
      console.log(this.formData.appointmentTime)
      if (this.formData.appointmentTime) {
        this.focusTime = this.formData.appointmentTime
      }
    },
    CompareDate(t1, t2) {
      var date = new Date();
      console.log(date)
      var a = t1.split(":");
      var b = t2.split(":");
      return date.setHours(a[0], a[1]) > date.setHours(b[0], b[1]);
    },
    pickDateChange(val) {
      var cc = val.split(' ')[1]
      var dd = '08:59:59'
      if (this.CompareDate(cc, dd) == false) {
        this.formData.appointmentTime = ''
        _g.toast("warning", "请选择九点之后的时间");
        return;
      }
      this.formData.doctorId = ''
      let year1 = this.focusTime.split('-')[0]
      let year2 = val.split('-')[0]
      let month1 = this.focusTime.split('-')[1]
      let month2 = val.split('-')[1]
      if (this.focusTime != '') {
        var day1 = this.focusTime.split('-')[2].substring(0, 2)
      }
      let day2 = val.split('-')[2].substring(0, 2)
      if (year1 == year2 && month1 == month2 && day1 == day2) {
        console.log('同一天')
      } else {
        console.log('更改日期')
        // 修改预约门诊时间时直接修改预约仪器部位时间
        console.log(this.editEppointmentPosition)
        let aa = this.editEppointmentPosition[0].useTime.search("undefined") != -1
        if (this.editEppointmentPosition[0].useTime != '' || aa == true) {
          this.editEppointmentPosition.forEach((ele, idx) => {
            let aa = ele.useTime.split(' ')[1]
            let bb = val.split(' ')[0]
            ele.useTime = bb + ' ' + aa
          });
        }
        // // 根据预约门诊时间和仪器id提示仪器已预约时间
        if (this.formData.instrumentId != '') {
          let queryData = {
            appointmentTime: this.formData.appointmentTime,
            instrumentId: this.formData.instrumentId,
          }
          api.request("/appointment/findInstrumentDateById", queryData, (res) => {
            if (res.result == true) {
              let dataTimeAppoint = res.data
              if (dataTimeAppoint.unoccupied) {
                this.editShowTime = true
                this.editSuccessAppointTime = dataTimeAppoint
              } else if (!dataTimeAppoint.unoccupied) {
                this.editShowTime = false
              }
            }
            this.$forceUpdate()
          }, (err) => { });
        }
        this.$forceUpdate()
      }
    },
    //  编辑时项目类型发生改变清空值
    editTypeChange() {
      this.formData.areaCode = this.areaType
      this.formData.floorCode = ''
      this.formData.instrumentId = ''
      this.formData.instrumentName = ''
      this.formData.doctorId = ''
      this.formData.doctorName = ''
      this.formData.projectId = ''
      this.formData.projectName = ''
      this.formData.remark = ''
      this.formData.dateFlag = false
      this.formData.timeFlag = true
      this.formData.appointStatus = ''
      this.editShowTime = false
      this.editEppointmentPosition = [{
        positionId: '',
        useTime: '',
        positionName: '',
        positionNameTime: '',
      }]
      if (this.areaType == 'fls') {
        this.formData.floorCode = '1'
        this.floorDisabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      } else if (this.areaType == 'bsl') {
        this.floorDisabled = false
      } else if (this.areaType == 'ntbsl') {
        this.formData.floorCode = '1'
        this.floorDisabled = true
        this.floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        }]
      }
    },
    floorChangeCopy() {
      this.formData.projectId = ''
      this.formData.instrumentId = ''
      this.formData.instrumentName = ''
      this.formData.doctorId = ''
      this.formData.doctorName = ''
      this.editEppointmentPosition = [{
        positionId: '',
        useTime: '',
        positionName: '',
      }]
      this.editSuccessAppointTime = ''
      this.editShowTime = false
      this.projectInstrument = []
      this.editPositionOptions = []
      this.projectDoctor = []
    },
    // 编辑操作根据选中的项目id查询可用仪器操作人等
    projectChangeEdit(val) {
      this.projectOptions.forEach(ele => {
        if (val == ele.id) {
          this.copyProjectName = ele.projectName
        }
      });
      this.projectIdData = val
      let querys = {
        id: val,
        areaCode: this.formData.areaCode,
        floorCode: this.formData.floorCode,
        areaType: this.areaType
      };
      api.request("/project/findProjectBydId", querys, (res) => {
        this.projectData = res.data
        // 编辑时部位回显
        if (this.formData) {
          this.projectInstrument = this.projectData.projectInstrument
          this.projectDoctor = this.projectData.projectDoctor
          this.projectDoctorList = this.projectData.projectDoctor
          this.formData.hmProjectName = this.projectData.hmProjectName
          this.projectDoctorList.forEach(ele => {
            ele.doctorId = ele.doctorId.toString()
          });
        }
        this.showOrHide(this.copyProjectName)
      }, (err) => { });
    },
    // 编辑弹框查询项目
    projectFocus(val) {
      let querys = {
        projectName: "",
        projectType: this.formData.projectType,
        areaCode: this.formData.areaCode,
        cityCode: this.cityCode
      };
      api.request("/project/findProjectListByName", querys, (res) => {
        if (res.data.length == 0) {
          _g.toast("warning", "还没有可选择的项目!");
        }
        this.projectOptions = res.data;
      }, (err) => { });
      this.formData.instrumentId = ''
      this.formData.instrumentName = ''
      this.formData.doctorId = ''
      this.formData.doctorName = ''
      this.editEppointmentPosition = [{
        positionId: '',
        useTime: '',
        positionName: '',
      }]
      this.editShowTime = false
      this.editSuccessAppointTime = ''
    },

    testSX() {
      console.log('强制刷新')
      this.$forceUpdate()
    },
    instrumentChange1(val) {
      this.arrList3 = val
      this.projectInstrument.forEach(item => {
        if (item.instrumentId == val) {
          this.listName1 = item.instrumentName
          console.log(this.listName1)
        }
      });
      this.editEppointmentPosition = [{
        positionId: '',
        useTime: '',
        positionName: '',
      }]
      this.editShowTime = false
      this.editSuccessAppointTime = ''
      this.formData.doctorId = ''
      this.formData.doctorName = ''
      // 根据预约门诊时间和仪器id提示仪器已预约时间
      if (this.formData.instrumentId != '') {
        let queryData = {
          appointmentTime: this.formData.appointmentTime,
          instrumentId: this.formData.instrumentId,
        }
        api.request("/appointment/findInstrumentDateById", queryData, (res) => {
          if (res.result == true) {
            let dataTimeAppoint = res.data
            if (dataTimeAppoint.unoccupied) {
              this.editShowTime = true
              this.editSuccessAppointTime = dataTimeAppoint
            } else if (!dataTimeAppoint.unoccupied) {
              this.editShowTime = false
            }
          }
          this.$forceUpdate()
        }, (err) => { });
      }
    },
    // 编辑时新增部位
    editAddDomain() {
      this.editEppointmentPosition.push({
        positionId: '',
        positionName: '',
        useTime: '',
        key: Date.now()
      });
    },
    // 编辑时删除部位
    editRemoveDomain(item, listIndex) {
      var index = this.editEppointmentPosition.indexOf(item)
      if (index !== -1) {
        this.editEppointmentPosition.splice(listIndex, 1)
      }
      this.offFirstEnter = false
    },
    docotrChange1(val) {
      this.arrList4 = val
      this.projectDoctor.forEach(item => {
        if (item.doctorId == val) {
          this.listName2 = item.doctorName
        }
      });
      this.offFirstEnter = false
    },
    // 确定修改项目
    edit() {
      console.log(this.formData)
      let empId = Lockr.get("empId");
      console.log(empId)
      if (!this.formData.instrumentId || this.formData.instrumentId == [] || this.formData.instrumentId.length == 0) {
        _g.toast("warning", "请选择使用仪器")
        return;
      }
      if (!this.formData.doctorId || this.formData.doctorId == [] || this.formData.doctorId.length == 0) {
        _g.toast("warning", "请选择操作人")
        return;
      }
      let dataList = JSON.parse(JSON.stringify(this.formData))
      if (this.projectIdData) {
        this.dataParam = {
          appointStatus: dataList.appointStatus,
          appointmentId: this.fatherId,
          appointmentTime: dataList.appointmentTime,
          completionTime: dataList.completionTime,
          createBy: dataList.createBy,
          createTime: dataList.createTime,
          customerName: dataList.customerName,
          delFlg: dataList.delFlg,
          doctorId: dataList.doctorId,
          doctorName: dataList.doctorName,
          instrumentDate: dataList.instrumentDate,
          instrumentId: dataList.instrumentId,
          instrumentName: dataList.instrumentName,
          instrumentUsetime: dataList.instrumentUsetime,
          instrumentUsetimeEnd: dataList.instrumentUsetimeEnd,
          mobile: dataList.mobile,
          operationStatus: dataList.operationStatus,
          positionName: dataList.positionName,
          projectId: this.projectIdData,
          projectName: this.projectData.projectName,
          remark: dataList.remark,
          updateBy: dataList.updateBy,
          updateTime: dataList.updateTime,
          userId: empId,
          appointmentPosition: this.editEppointmentPosition,
          areaCode: dataList.areaCode,
          floorCode: dataList.floorCode,
          projectType: dataList.projectType,
          areaType: this.areaType,
          hmProjectName: dataList.hmProjectName,
          cadCode: dataList.cadCode
        }
        if (this.projectData.projectInstrument) {
          this.dataParam.instrumentId = this.arrList3
          this.dataParam.doctorId = this.arrList4
        }
        if (this.listName2) {
          this.dataParam.doctorName = this.listName2
        }
        if (this.listName1) {
          this.dataParam.instrumentName = this.listName1
        }
        this.areaOptions.forEach(ele => {
          if (dataList.areaCode == ele.areaCode) {
            this.dataParam.areaName = ele.areaName
          }
        });
        this.floorOptions.forEach(ele => {
          if (dataList.floorCode == ele.floorCode) {
            this.dataParam.floorName = ele.floorName
          }
        });
      } else if (!this.projectIdData) {
        this.dataParam = {
          appointStatus: dataList.appointStatus,
          appointmentId: this.fatherId,
          appointmentTime: dataList.appointmentTime,
          completionTime: dataList.completionTime,
          createBy: dataList.createBy,
          createTime: dataList.createTime,
          customerName: dataList.customerName,
          delFlg: dataList.delFlg,
          doctorId: dataList.doctorId,
          doctorName: dataList.doctorName,
          instrumentDate: dataList.instrumentDate,
          instrumentId: dataList.instrumentId,
          instrumentName: dataList.instrumentName,
          instrumentUsetime: dataList.instrumentUsetime,
          instrumentUsetimeEnd: dataList.instrumentUsetimeEnd,
          mobile: dataList.mobile,
          operationStatus: dataList.operationStatus,
          positionName: dataList.positionName,
          projectId: dataList.projectId,
          projectName: dataList.projectName,
          remark: dataList.remark,
          updateBy: dataList.updateBy,
          updateTime: dataList.updateTime,
          userId: empId,
          appointmentPosition: this.editEppointmentPosition,
          areaCode: dataList.areaCode,
          floorCode: dataList.floorCode,
          projectType: dataList.projectType,
          areaType: this.areaType,
          hmProjectName: dataList.hmProjectName,
          cadCode: dataList.cadCode
        }
        if (this.listName2) {
          // console.log('修改操作人000')
          this.dataParam.doctorName = this.listName2
        } else if (!this.listName2) {
          // console.log('未修改操作人111')
          this.dataParam.doctorName = this.formData.doctorName
        }
        if (this.listName1) {
          // console.log('修改仪器000')
          this.dataParam.instrumentName = this.listName1
        } else if (!this.listName1) {
          // console.log('未修改仪器111')
          this.dataParam.instrumentName = this.formData.instrumentName
        }
        if (this.dataParam.areaCode == 'fls') {
          this.dataParam.floorCode = '1'
          this.floorOptions = [{
            floorName: '1楼',
            floorCode: '1'
          }]
        }
        this.areaOptions.forEach(ele => {
          if (dataList.areaCode == ele.areaCode) {
            this.dataParam.areaName = ele.areaName
          }
        });
        this.floorOptions.forEach(ele => {
          if (dataList.floorCode == ele.floorCode) {
            this.dataParam.floorName = ele.floorName
          }
        });
      }

      // 医生id回显转换
      this.dataParam.doctorId = this.dataParam.doctorId.toString()
      var that = this
      let sureData = {
        mobile: this.formData.mobile,
        customerName: this.formData.customerName,
        projectId: this.formData.projectId, // 项目id集合
        appointmentId: this.formData.appointmentId, // 修改时必传
        status: 2, // 1：新增 2：修改
        appointmentTime: this.formData.appointmentTime.split(' ')[0]
      }
      console.log('最后提交的数据dataList')
      console.log(this.dataParam)
      api.requestQuiet("/appointment/findDistinguishData", sureData, (res) => {
        if (res.data != 0) {
          this.$confirm("该客户在当前时间已预约过此项目,是否确定要重复预约？", {
            center: true,
          }).then((res) => {
            that.updateAppointmentList(this.dataParam)
          }).catch((err) => {
            // this.$message.error('删除失败！');
          });
        } else if (res.data == 0) {
          that.updateAppointmentList(this.dataParam)
        }
      }, (err) => { });
    },
    updateAppointmentList(dataParam) {
      api.requestQuiet("/appointment/updateAppointment", dataParam, (res) => {
        if (res.result == true) {
          this.EditdialogForm = false;
          if (res.data != '' || res.data) {
            _g.toast("success", res.data);
          }
          this.projectIdData = ''
          this.$emit('add-comment')
        } else {
          _g.toast("error", res.errMsg);
          this.$emit('add-comment')
        }
      }, (err) => { });
    },
    // 搜索查询全部可预约项目
    projectMethod(val, projectType) {
      let querys = {
        projectName: val,
        projectType: projectType,
        areaCode: this.formData.areaCode,
        cityCode: this.cityCode
      };
      api.request("/project/findProjectListByName", querys, (res) => {
        if (res.data.length == 0) {
          _g.toast("warning", "还没有可选择的项目!");
        }
        this.projectOptions = res.data;
      }, (err) => { });
    },
    // 编辑时筛选操作人
    docotrFocusEdit() {
      console.log(this.formData)
      // 根据选择仪器时间筛选操作人
      let arrForm = []
      this.projectDoctorList.forEach(ele => {
        arrForm.push(ele.doctorId)
      });
      let queryData = {
        appointmentTime: this.formData.appointmentTime,
        doctorIds: arrForm,
        instrumentId: this.formData.instrumentId,
        appointmentPosition: this.editEppointmentPosition,
        choiceDoctorId: this.formData.doctorId
      }
      api.request("/appointment/findDoctorByInstrumentDate", queryData, (res) => {
        if (res.result == true) {
          let resData = res.data
          // 筛选id相同的医生数据
          if (resData.length != 0) {
            resData.forEach(ele => {
              ele.doctorId = ele.doctorId.toString()
            });
            let add = this.projectDoctorList.filter(item => resData.some(ele =>
              ele.doctorId === item.doctorId))
            add.push({
              doctorId: '999999',
              doctorName: '无指定操作人'
            })
            this.projectDoctor = add
            console.log(this.projectDoctor)
          } else if (resData.length == 0) {
            this.projectDoctor = [{
              doctorId: '999999',
              doctorName: '无指定操作人'
            }]
          }
        }
      }, (err) => { });
    },
    // 编辑弹框仪器选择时间
    onBlurTimeEdit(val) {
      var oDate1 = new Date(this.formData.appointmentTime);
      var oDate2 = new Date(val.value);
      console.log(oDate1)
      console.log(oDate2)
      if (oDate1) {
        if (oDate1.getTime() > oDate2.getTime()) {
          _g.toast("warning", "预约仪器时间不得大于预约门诊时间");
          return; //第一个大
        }
      }
    },
    // 编辑时选择部位
    editPositionFocus(val, index) {
      if (!this.formData.instrumentId || this.formData.instrumentId == undefined || this.formData.instrumentId ==
        '') {
        _g.toast("warning", "请先选择仪器");
        return;
      }
      api.request("/instrument/findInstrumentById", {
        instrumentId: this.formData.instrumentId
      }, (res) => {
        this.$nextTick(() => {
          this.editPositionOptions = res.data.InstrumentPosition
          this.editPositionOptions.map((x, i) => {
            this.editEppointmentPosition.map((s) => {
              if (x.positionId === s.positionId) {
                x.disabled = true
              }
            })
          })
          this.$forceUpdate()
        });
      }, (err) => { })
    },
    // 编辑时部位值改变事件
    editPositionChange(val, idx) {
      this.offFirstEnter = false
      this.editEppointmentPosition[idx].positionId = val
      this.editPositionOptions.forEach(ele => {
        if (val == ele.positionId) {
          this.editEppointmentPosition[idx].positionName = ele.positionName
        }
      });
      if (this.arrList3.length != 0) {
        console.log('改变仪器值')
        this.instrumentNum = this.arrList3
      } else if (this.arrList3.length == 0) {
        console.log('没有改变仪器值')
        this.instrumentNum = this.formData.instrumentId
      }
      api.request("/instrument/findInstrumentById", {
        instrumentId: this.instrumentNum
      }, (res) => {
        this.$nextTick(() => {
          this.editPositionOptions = res.data.InstrumentPosition
          this.editPositionOptions.map((x, i) => {
            this.editEppointmentPosition.map((s) => {
              if (x.positionId === s.positionId) {
                x.disabled = true
              }
            })
          })
          this.$forceUpdate()
        });
      }, (err) => { })
    },

  },
}
</script>
<style scoped>
@import "../../assets/css/main.css";

.dialogItem>>>.el-input__inner {
  height: 34px;
  background: #ffffff;
  /* box-shadow: 0px 0px 5px 3px #caeafd; */
  border-radius: 3px;
  /* border: 1px solid #23a2ee; */
}

.dialogItem>>>.el-form-item__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #626365;
  width: 96px;
}

.partFooter>>>.el-button--primary {
  width: 125px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.checkButton>>>.el-button--primary {
  width: 98px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.partFooter>>>.el-button--danger {
  width: 125px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid #5a7ef8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5a7ef8;
  line-height: 2px;
  background: none;
}

.pageInput>>>.el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}

.pageInput>>>.el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}

.appointTimeLong {
  text-align: left;
  margin-left: 5%;
  width: 400px;
}

.appointTimeLong>>>.el-tag {
  margin-bottom: 10px;
  margin-right: 10px;
}

.instrucPosition>>>.el-button i {
  margin: 0 !important;
}

.dialogItem>>>.el-form-item__error {
  left: 30px !important;
}

.tips>>>.el-input__inner {
  background-color: #ecf5ff;
  border-color: #d9ecff;
  color: #409eff;
  width: 155px;
}

.tooltips>>>.el-input__inner {
  background-color: #fef0f0;
  border-color: #fde2e2;
  color: #f56c6c;
  width: 155px;
}

.tips>>>.el-icon-arrow-up:before {
  color: #409eff;
}

.tooltips>>>.el-icon-arrow-up:before {
  color: #f56c6c;
}
</style>
